import { render, staticRenderFns } from "./project-phone-view.vue?vue&type=template&id=287e81e8&scoped=true&"
import script from "./project-phone-view.vue?vue&type=script&lang=js&"
export * from "./project-phone-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e81e8",
  null
  
)

export default component.exports